import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import SmoothCollapse from 'react-smooth-collapse';
import Toggle from 'react-toggle';
import { useToasts } from 'react-toast-notifications';
import ChevronRightIcon from 'calcite-ui-icons-react/ChevronRightIcon';

import CriterionSection from './criterion-section';

import MapController from '../../../../controllers/MapController';

import { RootState } from '../../../../reducers/app';
import { toggleMapLoader } from '../../../../reducers/mapview/actions';

import { ICriterion } from '../../../../types/audit-config';

import 'react-toggle/style.css';
import './criterion.scss';
import { leftpanel } from '../../../../config/leftpanel.config';
import Icon from '../../../../assets';
import InfoSvg from '../../../../assets/info-icon';
import config from '../../../../config/config';
import LayerTooltip from '../layer-components/layer-tooltip';
import ReactTooltip from 'react-tooltip';

/**
 * Wrapper component for the criterion section
 */
const CriterionWrapper = ({ criterion }: { criterion: ICriterion }) => {
  // LOCAL STATE
  const [activeSection, setActiveSection] = useState(false);

  // REDUX
  const performAuditLayer = useSelector((state: RootState) => state.mapview.performAuditLayers).find(
    (criteriaLayer) => criteriaLayer.criteriaNumber === criterion.criteria
  );
  const dispatch = useDispatch();

  const { addToast } = useToasts();

  const toggleMask = () => {
    MapController.applyPerformAuditMask(criterion.criteria)
      .then((res: string) => {
        addToast(res, { appearance: 'success', autoDismiss: true });
        dispatch(toggleMapLoader(false));
      })
      .catch((res: string) => {
        addToast(res, { appearance: 'error', autoDismiss: true });
        dispatch(toggleMapLoader(false));
      });
  };

  const hansenEndMark = leftpanel.hansenEndYear - 2000;

  return (
    <div className='criterion-container'>
      <div className='criterion-container__banner'>
        <div className='criterion-container__title' onClick={() => setActiveSection(!activeSection)}>
          <ChevronRightIcon className={activeSection ? 'open' : ''} size={18} />
          <div className='title'>Criterion {criterion.criteria}</div>
        </div>
        {performAuditLayer?.hansenCounts && performAuditLayer?.hansenCounts[hansenEndMark] && (
          <React.Fragment>
            <LayerTooltip tip={config.helpertext.hansenAlertInfo}>
              <Icon name='alert' color={'red'} className='criterion-alert-icon' size={24} />
            </LayerTooltip>
            <ReactTooltip
              className='tooltip'
              id='tooltip'
              place='right'
              multiline={true}
              type='success'
              effect='solid'
              clickable={true}
            />
          </React.Fragment>
        )}
        {(performAuditLayer && performAuditLayer.intersecting) && (
          <Toggle
            className='criterion-container-toggle'
            icons={false}
            checked={performAuditLayer.visible}
            onChange={() => toggleMask()}
          />
        )}
        <LayerTooltip tip={criterion.tooltip}>
          <InfoSvg className='criterion-info' />
        </LayerTooltip>
        <ReactTooltip
          className='tooltip'
          id='tooltip'
          place='right'
          multiline={true}
          type='success'
          effect='solid'
          clickable={true}
        />
      </div>
      <SmoothCollapse expanded={activeSection} className='criterion-container__sections' allowOverflowWhenOpen eagerRender={true}>
        <CriterionSection criterion={criterion} performAuditLayer={performAuditLayer} />
      </SmoothCollapse>
    </div>
  );
};

export default CriterionWrapper;
